module.exports = __webpack_public_path__ + "static/img/announcement.5c7fc42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/announcement.png
// module id = ut9u
// module chunks = 4